import { Html } from '@react-three/drei';

import { ControlContext } from 'provider/ControlProvider';
import { memo, useContext } from 'react';
import {
  LockClosedIcon,
  MapPinIcon,
  PhotoIcon,
  TvIcon,
} from '@heroicons/react/24/outline';

type Props = {
  name?: string;
  pos: Array<number>;
  url?: string;
  index?: number;
  scale?: Array<number>;
  type?: number;
};

const Mark = ({
  name = 'Unknown',
  pos,
  url = '/arealist/question.jpg',
  index = 0,
  scale = [0.015, 0.015, 0.015],
  type = 0,
}: Props) => {
  const { setContent } = useContext(ControlContext);
  return (
    <Html
      scale={[scale[0], scale[1], scale[2]]}
      transform
      sprite
      name={name}
      position={[pos[0], pos[1], pos[2]]}
    >
      <div className='w-96 flex flex-col items-center justify-center '>
        <button
          className='relative'
          onClick={() =>
            setContent({
              type: type,
              index: index,
              url: url,
            })
          }
        >
          <img
            src={url}
            className='border-4 w-40 h-40 select-none border-white rounded-full opacity-40 hover:opacity-100'
            alt='Spore&aposs Mystery Area Point For Journey'
          />
        </button>
        <h3 className='relative text-white text-center  p-2'>
          {name}
          {type === 0 ? (
            <LockClosedIcon className='absolute -left-8 top-0 w-10 h-auto text-white' />
          ) : type === 1 ? (
            <MapPinIcon className='absolute -left-8 top-0 w-10 h-auto text-white' />
          ) : type === 2 ? (
            <PhotoIcon className='absolute -left-8 top-0 w-10 h-auto text-white' />
          ) : type === 3 ? (
            <TvIcon className='absolute -left-8 top-0 w-10 h-auto text-white' />
          ) : (
            <LockClosedIcon className='absolute -left-8 top-0 w-10 h-auto text-white' />
          )}
        </h3>
      </div>
    </Html>
  );
};

export default memo(Mark);
